var _path, _path2, _path3, _circle, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJoinOrganization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 77,
    viewBox: "0 0 84 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.8125 63.9554H65.2554C62.5637 63.9554 60.0066 64.9984 58.1225 66.8825L52.369 72.5687C49.7446 75.1594 45.4717 75.1594 42.8473 72.5687L37.0938 66.8825C35.2097 64.9984 32.619 63.9554 29.9609 63.9554H27.4375C21.8523 63.9554 17.3438 59.4806 17.3438 53.9626V17.2549C17.3438 11.737 21.8523 7.26221 27.4375 7.26221H67.8125C73.3977 7.26221 77.9062 11.737 77.9062 17.2549V53.9626C77.9062 59.4469 73.3977 63.9554 67.8125 63.9554Z",
    stroke: "#8898CA",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6266 34.1452C51.9563 34.1452 55.4662 30.6353 55.4662 26.3056C55.4662 21.976 51.9563 18.4663 47.6266 18.4663C43.297 18.4663 39.7871 21.976 39.7871 26.3056C39.7871 30.6353 43.297 34.1452 47.6266 34.1452Z",
    stroke: "#8898CA",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0846 53.1891C61.0846 47.1328 55.062 42.2207 47.6263 42.2207C40.1906 42.2207 34.168 47.1328 34.168 53.1891",
    stroke: "#8898CA",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 57.5,
    r: 19,
    fill: "#008ABD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5432 61.5598H16.7409C16.7515 60.6221 16.8311 59.8183 16.9795 59.1485C17.1386 58.4787 17.3985 57.8759 17.7591 57.3401C18.1197 56.7939 18.6076 56.2375 19.2227 55.6707C19.7106 55.2276 20.1455 54.8103 20.5273 54.4187C20.9197 54.0168 21.2273 53.5995 21.45 53.1667C21.6727 52.7236 21.7841 52.2238 21.7841 51.6673C21.7841 51.0388 21.678 50.5132 21.4659 50.0907C21.2644 49.6682 20.9621 49.3488 20.5591 49.1324C20.1667 48.9057 19.6735 48.7923 19.0795 48.7923C18.5917 48.7923 18.1303 48.8902 17.6955 49.086C17.2606 49.2818 16.9106 49.5858 16.6455 49.998C16.3803 50.3999 16.2371 50.9254 16.2159 51.5746H12C12.0318 50.2247 12.3606 49.1015 12.9864 48.205C13.6121 47.2982 14.4553 46.6232 15.5159 46.1801C16.5765 45.7267 17.7644 45.5 19.0795 45.5C20.5326 45.5 21.7735 45.737 22.8023 46.211C23.8417 46.6747 24.6318 47.3548 25.1727 48.2513C25.7242 49.1478 26 50.2298 26 51.4973C26 52.4041 25.8197 53.2182 25.4591 53.9395C25.0985 54.6505 24.6212 55.3152 24.0273 55.9335C23.4333 56.5517 22.7917 57.1752 22.1023 57.8038C21.4977 58.3293 21.0894 58.8909 20.8773 59.4886C20.6652 60.0862 20.5538 60.7767 20.5432 61.5598ZM16.3432 66.3669C16.3432 65.7487 16.5553 65.2334 16.9795 64.8212C17.4144 64.409 17.9977 64.203 18.7295 64.203C19.4614 64.203 20.0394 64.409 20.4636 64.8212C20.8985 65.2334 21.1159 65.7487 21.1159 66.3669C21.1159 66.9646 20.8985 67.4695 20.4636 67.8817C20.0394 68.2939 19.4614 68.5 18.7295 68.5C17.9977 68.5 17.4144 68.2939 16.9795 67.8817C16.5553 67.4695 16.3432 66.9646 16.3432 66.3669Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinOrganization);
export default __webpack_public_path__ + "static/media/joinOrganization.fde9f2eefd8cfad7b3d2106cd684aa94.svg";
export { ForwardRef as ReactComponent };